import './App.css';
import './V2Card.css';

function V2Card(props) {
    return (
        <div className='v2-card'>
            {props.children}
        </div>
    );
}

export default V2Card;